import { Pipe, PipeTransform } from '@angular/core';
import { ContentViewModel, ExtendedContentData, ObservableContentService } from 'osn-shared';
import { Observable } from 'rxjs';

@Pipe({ name: 'contentExtendedData', pure: false })
export class ContentExtendedDataPipe implements PipeTransform {
  constructor(private readonly observableContentService: ObservableContentService) {}

  // eslint-disable-next-line rxjs/finnish
  public transform(value: ContentViewModel): Observable<ExtendedContentData> {
    // TODO [MO]: WTF is wrong with the overload here
    return this.observableContentService.getObservableProgram$(value as any).extendedContentData.get();
  }
}
